import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } 	from 'gsap/ScrollSmoother';
gsap.registerPlugin( ScrollTrigger, ScrollSmoother );

export default class {

    constructor(options) {


    	// VIMEO, for video rollovers maybe bets look at:
    	// https://vimeo.zendesk.com/hc/en-us/articles/224823567-Direct-links-to-video-files

        // OPTIONS
        this.defaults = {

            $el: undefined,
            main: undefined,

            firstTime: true

        }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'directors_control';

		// DOM ELEMENT !!!!!!!!!!
		this.$el 		= this.options.$el;
		this.main 		= this.options.main;

		// vars
		this.$win 		= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $( 'body' );

		this.$preview 	= this.$el.find( '.display_image' );
		this.$imgs_vertical      = this.$preview.find( '.container.is-vertical' );

		this.previewActive = false;
		this.max 		= this.$el.find( '.director' ).length + 7;

		this.ids = [];

		this.$directors = this.$el.find( '.director' );
		
		this.mode 		= this.$el.attr( 'data-mode' );

		this.video_mode = this.$el.attr( 'data-video-mode' );

		if ( this.mode === 'index' ){
			this.previews = [];
			this.$preview.find( '.container' ).each( (i, el)=>{

				this.previews[ i ] = {
					$el: $(el),
					index : parseInt( $(el).attr( 'data-index' ) ),
					$videoPlayer : $(el).find( '.video-player' ),
					$video : $(el).find( 'video' )
				}

			}); 
		}

		// init!!!!
		this.init( true );

		if ( this.options.firstTime ){
			this.animateIntroDirectors( true );
		}
		else{
			this.$el.addClass( 'ready' );
		}
		
		this.$el.addClass( 'start' );

    }

	init( b ){

		//console.log( 'init, b = ' + b  );

		this.previewActive = true;

		this.debounceResize( b, b);
		//this.initScrollTrigger(b);
		this.initDirectorsHover( b );

		this.previewActive = false;
		//this.initDirectorsfilters( b );

	}


	animateIntroDirectors( onlynames ){
		let $director, $header = $( '.desktop-menu-container' ),
		t = gsap.timeline({delay:0.8, onComplete: ()=> this.initIntroDirectors( false, onlynames ) });

		this.initIntroDirectors( true, onlynames );
		this.$directors.each( (i,el) => {

			$director = $(el);

			t.from( el, { x: -20, opacity:0, duration: 0.27, ease:'power1.out' }, '-=0.13' );

			if ( !onlynames ){
				t.set( [this.$body, $header], { 'background-color' : $(el).attr( 'data-color' ) } );
				t.add( () => this.setDirectorThumbnailPreview( $director, true, i ) );
				t.add( () => gsap.set( $director, { 'z-index': this.max } ) );
			}

		})
	}

	initIntroDirectors( b, onlynames ){
		let $header = $( '.desktop-menu-container' );
		if ( b ){

			if ( !onlynames ){
				this.$body.addClass( 'no-transition' );
				$header.addClass( 'no-transition' );
				this.previewActive = true;
				gsap.set( this.$preview, { 'opacity': 1 } );
			}
			else{
				this.$el.addClass( 'ready' );
			}

		}
		else{

			if ( !onlynames ){
				this.$body.removeClass( 'no-transition' );
				$header.removeClass( 'no-transition' );
				this.previewActive = false;
				gsap.set( this.$preview, { 'opacity': 0 } );
				this.setBodyColor(-1);

				this.$el.addClass( 'ready' );
			}

		}
	}

	//-----------------------------------------------------[  PREVIEW ]------------------------------------------------------------//
	initDirectorsHover( b ){

		let $directors_control = this.$el; //this.$el.find( '.directors-control' );
		if ( b ){
			$directors_control.find( '.director a' ).on( 'mouseenter', ( e )=>this.directorOnMouseEnter(e,true) );
			$directors_control.find( '.director a' ).on( 'mouseleave', ( e )=>this.directorOnMouseEnter(e,false) );

			this.$win.on( 'scroll', ()=>this.setPreviewPosition() );
		}	
		else{
			$directors_control.find( '.director a' ).off( 'mouseenter', ( e )=>this.directorOnMouseEnter(e,true) );
			$directors_control.find( '.director a' ).off( 'mouseleave', ( e )=>this.directorOnMouseEnter(e,false) );

			this.$win.off( 'scroll', ()=>this.setPreviewPosition() );
		}
	}

	directorOnMouseEnter(e,b){
		let $director 	= $(e.currentTarget).parents( '.director' ), index = parseInt( $director.attr( 'data-index' ) ), color = $director.attr( 'data-color' );


		this.previewActive = b;

		this.setDirectorThumbnailPreview( $director, b, index );


		if ( b ){
			gsap.set( $director, { 'z-index': this.max } );
			gsap.set( this.$preview, { 'opacity': 1 } );

			this.setDirectorNameColor( index );

			this.setBodyColor( color );

		}
		else{
			gsap.set( $director, { 'z-index': 0 } );

			gsap.set( this.$preview, { 'opacity': 0 } );	

			this.setDirectorNameColor( -1 );

			this.setBodyColor( -1 );
		}

		this.playVimeoVideoFile( $director, b );

	}

	playVimeoVideoFile( $director, b ){
		if ( $director.attr( 'data-file' ) !== 'no' ){
			let index = parseInt( $director.attr( 'data-index' ) ), $video = this.previews[ index ].$video;
			if ( $video.length > 0 ){
				if ( b ){

					if ( this.video_mode === 'preload' ){
						$video.get(0).play();
						$video.addClass( 'canplay' );
					}
					else{
						//$video.get(0).pause();
						if ( ! $video.find( 'source' ).attr( 'src') ){
							$video.find( 'source' ).attr( 'src', $director.attr( 'data-file' ) );
							$video.get(0).load();
							$video.on( 'canplay' , ()=>{
								$video.addClass( 'canplay' );
							})
						}
						$video.get(0).play();
					}


					
				}
				else{

					if ( this.video_mode === 'preload' ){
						$video.get(0).pause();
					}
					else{
						$video.get(0).pause();
					}
				}
			}
		}
	}


	setBodyColor( color ){
		if ( color === -1 ){
			//this.main.changePageColor( $('#main') );
			color = this.$body.attr( 'data-chose-color' );

			gsap.set( this.$body, { 'background-color': color } );
			gsap.set( $( '.desktop-menu-container .int' ), { 'background-color' : this.main.convertHexToRGBA(color,0.9) } );
			return;
		}

		//console.log( color );

		gsap.set( this.$body, { 'background-color': color } );
		gsap.set( $( '.desktop-menu-container .int' ), { 'background-color' : this.main.convertHexToRGBA(color,0.9) } );

	}

	setDirectorNameColor( index ){
		let $director, director_index;

		//console.log( index );

		this.$directors.each( (i, el)=>{
			$director = $(el);
			
			director_index = parseInt( $director.attr( 'data-index' ) );

			if ( director_index !== undefined ){

				//console.log( director_index );

				if ( index === -1 ){
					$director.removeClass( 'inactive' );
				}
				else{
					if ( index === director_index ){
						$director.removeClass( 'inactive' );
					}
					else{
						$director.addClass( 'inactive' );
					}
				}
			}
			else{

				// In development
				
				if ( index === -1 ){
					$director.removeClass( 'inactive' );
				}
				else{
					$director.addClass( 'inactive' );
				}
			}
		});
	}


	setDirectorThumbnailPreview( $director, b, index ){


		if ( this.mode === 'index' ){

			let i = this.previews.length, p, videoPlayerInstance;

			while( i-- ){
				p = this.previews[ i ]; 
				if ( b ){

					if ( p.index === index ){


						if ( p.$videoPlayer.length > 0 ){
							videoPlayerInstance = p.$videoPlayer.data('widget');
							if ( videoPlayerInstance ){
								videoPlayerInstance.forceResize();
								videoPlayerInstance.play( true );
							}
						}



						gsap.set( p.$el, {opacity:1} );

						p.$el.addClass( 'is-active' );
					}
					else{
						gsap.set( p.$el, {opacity:0} );

						p.$el.removeClass( 'is-active' );

						if ( p.$videoPlayer.length > 0 ){
							videoPlayerInstance = p.$videoPlayer.data('widget');
							if ( videoPlayerInstance ){
								videoPlayerInstance.play( false );
							}
						}

					}
					
				}
				else{
					gsap.set( p.$el, {opacity:0} );

					p.$el.removeClass( 'is-active' );


					if ( p.$videoPlayer.length > 0 ){
						videoPlayerInstance = p.$videoPlayer.data('widget');
						if ( videoPlayerInstance ){
							videoPlayerInstance.play( false );
						}
					}
				}
			}

			if ( b ){
				this.setPreviewPosition();
			}

		}
		else{

			// reset
			this.$preview.html( '' ).css( 'height', 'auto' );

			if ( b ){


				let $script = $director.find( 'script' );
				if ( $script.length > 0 ){
					this.$preview.html( $script.html() );
				}

				this.setPreviewPosition();
				
			}

		}
	}


	setPreviewPosition( ){

		if ( !this.previewActive ){
			//return;
		}

		//console.log( 'setPreviewPosition' );

		const max_size = true;

		let margenH = $('.page-menu').height(), margen = 20, h, minHeight = 100, y,
						$container_vertical, $img_vertical;


		if ( max_size ){

			this.$preview.css({
				'max-width': 1240,
				'width' : '100%',
				'height' : 'auto',
				'margin-top': 0
			});

			this.$preview.height( Math.round( this.$preview.width()*9/16 ) );

			y = Math.max( this.$win.scrollTop() - this.$el.offset().top + margenH , this.$win.scrollTop() + this.$win.height()/2 - this.$preview.height()/2 - this.$el.offset().top );

			h = Math.max( minHeight, this.$win.height() - margenH - margen );

			if ( h < this.$preview.height() ){

				this.$preview.height( h );
				this.$preview.width( Math.round( h*16/9 ) );
				this.$preview.css({
					'margin-top' : margenH/2
				});

				y = this.$win.scrollTop() + this.$win.height()/2 - this.$preview.height()/2 - this.$el.offset().top;
			} 

			// vertical images
			if ( this.$imgs_vertical.length > 0 ){
				this.$imgs_vertical.each((i,el) => {
					$container_vertical 	= $(el);
					$img_vertical 			= $container_vertical.find( '.img-wrapper' );

					$container_vertical.css({
						width: this.$preview.height()*$img_vertical.attr('data-width')/$img_vertical.attr('data-height'),
						height: this.$preview.height()
					})


				});
			}

			


			gsap.set( this.$preview, { y: y, x: this.$el.width()/2 - this.$preview.width()/2 } );

			
		}
		else{
			 this.$preview.css({
			 	'max-width': 1240
			 });
			 this.$preview.height( Math.round( this.$preview.width()*9/16 ) );

			 h = this.$preview.height();
			 gsap.set( this.$preview, { y: this.$win.scrollTop() + this.$win.height()/2 - h/2 - this.$el.offset().top , x: this.$el.width()/2 - this.$preview.width()/2, height: h } );
		}

	}


	//-----------------------------------------------------[  FILTERS ]------------------------------------------------------------//
	initDirectorsfilters( b ){

		this.$filter = $( 'ul.filters' );

		if ( this.$filter.length > 0 ){

			if ( b ){

				this.$filter.find( 'a' ).on( 'click', (e)=>this.onFilterSelect( e ) );
				this.$filter.find( 'li.current-menu-item a' ).css( 'pointer-events', 'none' );
			
			}
			else{

				this.$filter.find( 'a' ).off( 'click', (e)=>this.onFilterSelect( e ) );

			}

		}

	}

	onFilterSelect( e ){
		e.preventDefault();
		let $a = $(e.currentTarget), $li = $a.parent( 'li' ), $lis = this.$filter.find( 'li' ), $directors = this.$el.find( '.director' ), $d, class_filter;

		if ( $li.hasClass( 'current-menu-item' ) ){
			return;
		}

		$lis.removeClass( 'current-menu-item' );
		$lis.find( 'a' ).css( 'pointer-events', 'auto' );

		$li.addClass( 'current-menu-item' );
		$a.css( 'pointer-events', 'none' );

		class_filter = $a.attr( 'data-filter' );


		$directors.each( ( i, el )=>{

			$d = $(el);

			if ( class_filter === 'all' ){
				this.showDirector( $d, true );
			}
			else{
				this.showDirector( $d, $d.hasClass( class_filter ) );
			}

		});
		//console.log( class_filter );
	}

	showDirector( $d, b ){
		if ( b ){
			$d.show();
		}
		else{
			$d.hide();
		}
	}


	/*
	initScrollTrigger(b){
		if ( b ){
			let $slides = this.$el.find( '.home-promo-slide' ), $slide, $img, $video;
			if ( $slides.length > 0 ){
				$slides.each( ( i, el ) => {

					$slide  	= $(el);
					$img 		= $slide.find( '.display-inner' );

					// if video add listener to video play/pause
					if ( $slide.hasClass( 'is-video' ) ){

						$video = $slide.find( '.video-player' );
						this.initVideo( $video, true);
						
						this.videos[ this.videos.length ] = $video;
					}
					
					gsap.fromTo( $img, { y: $slide.height() - $img.height() },
						{
							y: 0,
							ease: "none",
							scrollTrigger: {
								trigger: $slide,
								start: "top bottom-=100px", // the default values
								end: "bottom top+=100px",
								scrub: true,
								markers: false, //i===0,
								id: this.getID(),
								// toggleClass: 'in-view'
							} 
						}
					);				
					
				})
			}
		}
		else{
			this.destroyScrollTriggers();
		}
	}
	*/

    debounceResize(b, resize){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 17 );
			$(window).on( 'resize', this._debResize );
			if ( resize ){
				this.onResize();
			}
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				$(window).off( 'resize', this._debResize );
			}        
		}
    }

    onResize(){

    	this.setPreviewPosition();
    }

	//--------------------- UTILS ----------------------//
	getID(){
		const id = 'id_' + this.namespace + '_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroyScrollTriggers(){
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
	}

    destroy(){
		this.init( false );
    }

}